export default {
  SET_HOVEREVENT(state, payload) {
    state.hoverEvent = payload; // eslint-disable-line
  },

  SET_BTNANIMATION(state, payload) {
    state.btnAnimation = payload; // eslint-disable-line
  },

  TOGGLE_MOUSEDOWN(state, payload) {
    state.mouseDown = payload; // eslint-disable-line
  },

  ADD_BUTTONS(state, payload) {
    state.ctxButtons = payload; // eslint-disable-line
  },

  SET_WEATHERDATA(state, payload) {
    state.weatherData = payload; // eslint-disable-line
  },

  SET_EVENTSLIST(state, payload) {
    state.eventsList = payload; // eslint-disable-line
  },

  ADD_EVENT(state, payload) {
    state.events.push(payload); // eslint-disable-line

    state.currentEvent = payload.id; // eslint-disable-line
    state.currentEventData = payload; // eslint-disable-line
  },

  SET_EVENT(state, payload) {
    state.currentEvent = payload.id; // eslint-disable-line
    state.currentEventData = payload; // eslint-disable-line
  },

  CHANGE_LANG(state, payload) {
    state.lang = payload; // eslint-disable-line
  },

  IS_CHANGING_LANG(state, payload) {
    state.changeLang = payload; // eslint-disable-line
  },


  ALL_LOADED(state, payload) {
    state.allLoaded = payload; // eslint-disable-line
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js